import React from "react";
import styles from "./Landing.module.css";
import { Statistics } from "./Statistics/Statistics.page";
import { Home } from "./Home/Home.page";

export const Landing = () => {
  return (
    <div className={styles.container}>
      <Home />
      <Statistics />
    </div>
  );
};
